// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEnquiry_root__yhp_7","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__qw9io"};